export default __webpack_public_path__ + "static/media/approved-icon-w.09efa949.svg";